module.exports = __webpack_public_path__ + "static/media/unico-erp.8b1d04b3.webp";